import { IVoiceProps } from '@/entities/Voice'
import Voice from '@/gateways/MicrocmsGateway/types/voice'

export function toVoiceProps(data: Voice): IVoiceProps {
  const { id, content, title, author, article_image } = data
  return {
    id,
    content,
    title,
    author,
    articleImage: article_image.url
  }
}
